import { readSettings } from '../platform/settings';
import { applyUiLocale } from './index';

/**
 * Resolve the interface language once, before the first render.
 *
 * Its own module rather than a line in `main.tsx` for one reason: `strings/index.ts` must not import
 * `platform/settings.ts`. The catalogue is read by `api/problem.ts`, which `core-testkit` imports and
 * runs under `node --test` with no dependencies, and the settings store reaches `localStorage` on the
 * way in. So the *reading* of the setting lives here, at the boot edge, and the catalogue stays a
 * module anything can import.
 *
 * `platform/settings.ts` calls {@link applyUiLocale} too, on every write — the same pair
 * `platform/theme.ts` insists on, where storing a value and applying it are deliberately two acts.
 */
export function initUiLocale(): void {
  applyUiLocale(readSettings().uiLocale);
}
